module.exports = __webpack_public_path__ + "img/scroll-icon.c05d1cb3.svg";